import React from 'react';
import { Gauge, Activity, UserPlus } from 'lucide-react';

const SubmissionsPieChart = ({ earlyAccessCount, contactFormCount, updatesCount }) => {
  const total = earlyAccessCount + contactFormCount + updatesCount;
  
  // Calculate percentages for each category
  const calculatePercentage = (value) => {
    return total === 0 ? 0 : Math.round((value / total) * 100);
  };
  
  const earlyAccessPercentage = calculatePercentage(earlyAccessCount);
  const contactFormPercentage = calculatePercentage(contactFormCount);
  const updatesPercentage = calculatePercentage(updatesCount);
  
  // Function to determine color class based on percentage
  const getColorClass = (percentage) => {
    if (percentage >= 50) return "bg-blue-500"; // Primary blue for high values
    if (percentage >= 30) return "bg-green-500"; // Green for medium values
    return "bg-red-500"; // Red for low values
  };
  
  // Function to determine text color based on percentage
  const getTextColorClass = (percentage) => {
    if (percentage >= 50) return "text-blue-500"; // Primary blue for high values
    if (percentage >= 30) return "text-green-500"; // Green for medium values
    return "text-red-500"; // Red for low values
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 w-full">
      <h2 className="text-xl font-semibold text-gray-800 mb-4 sm:mb-6 text-center">
        Submission Distribution
      </h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        {/* Early Access Gauge */}
        <div className="bg-white rounded-lg p-4">
          <div className="flex items-center mb-4">
            <UserPlus className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-blue-500" />
            <h3 className="text-base sm:text-lg font-semibold">Early Access</h3>
          </div>
          <div className="relative h-4 bg-gray-200 rounded-full mb-2">
            <div
              className={`absolute left-0 top-0 h-full rounded-full transition-all duration-500 ${getColorClass(earlyAccessPercentage)}`}
              style={{ width: `${earlyAccessPercentage}%` }}
            ></div>
          </div>
          <div className="flex justify-between items-center">
            <span className={`font-bold ${getTextColorClass(earlyAccessPercentage)}`}>
              {earlyAccessPercentage}%
            </span>
            <span className="text-gray-600 text-sm">
              {earlyAccessCount} submissions
            </span>
          </div>
        </div>

        {/* Contact Form Gauge */}
        <div className="bg-white rounded-lg p-4">
          <div className="flex items-center mb-4">
            <Activity className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-green-500" />
            <h3 className="text-base sm:text-lg font-semibold">Contact Form</h3>
          </div>
          <div className="relative h-4 bg-gray-200 rounded-full mb-2">
            <div
              className={`absolute left-0 top-0 h-full rounded-full transition-all duration-500 ${getColorClass(contactFormPercentage)}`}
              style={{ width: `${contactFormPercentage}%` }}
            ></div>
          </div>
          <div className="flex justify-between items-center">
            <span className={`font-bold ${getTextColorClass(contactFormPercentage)}`}>
              {contactFormPercentage}%
            </span>
            <span className="text-gray-600 text-sm">
              {contactFormCount} submissions
            </span>
          </div>
        </div>

        {/* Updates Gauge */}
        <div className="bg-white rounded-lg p-4">
          <div className="flex items-center mb-4">
            <Gauge className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-red-500" />
            <h3 className="text-base sm:text-lg font-semibold">Updates</h3>
          </div>
          <div className="relative h-4 bg-gray-200 rounded-full mb-2">
            <div
              className={`absolute left-0 top-0 h-full rounded-full transition-all duration-500 ${getColorClass(updatesPercentage)}`}
              style={{ width: `${updatesPercentage}%` }}
            ></div>
          </div>
          <div className="flex justify-between items-center">
            <span className={`font-bold ${getTextColorClass(updatesPercentage)}`}>
              {updatesPercentage}%
            </span>
            <span className="text-gray-600 text-sm">
              {updatesCount} submissions
            </span>
          </div>
        </div>
      </div>
      
      <div className="mt-6 pt-4 border-t border-gray-200 text-center">
        <p className="text-gray-600">
          Total Submissions: <span className="font-semibold">{total}</span>
        </p>
      </div>
    </div>
  );
};

export default SubmissionsPieChart;




// import React from 'react';
// import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

// const COLORS = ['#0C60F2', '#16A34A', '#DC2626'];

// const SubmissionsPieChart = ({ earlyAccessCount, contactFormCount, updatesCount }) => {
//  const data = [
//    { name: 'Early Access', value: earlyAccessCount },
//    { name: 'Contact Form', value: contactFormCount },
//    { name: 'Updates', value: updatesCount }
//  ];

//  const total = data.reduce((sum, entry) => sum + entry.value, 0);

//  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
//    const RADIAN = Math.PI / 180;
//    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//    const x = cx + radius * Math.cos(-midAngle * RADIAN);
//    const y = cy + radius * Math.sin(-midAngle * RADIAN);

//    return (
//      <text 
//        x={x} 
//        y={y} 
//        fill="white" 
//        textAnchor="middle" 
//        dominantBaseline="central"
//      >
//        {`${(percent * 100).toFixed(0)}%`}
//      </text>
//    );
//  };

//  return (
//    <div className="bg-white rounded-lg p-4 md:p-6 w-full">
//      <h2 className="text-xl font-semibold text-center mb-4">
//        Submission Distribution
//      </h2>
     
//      <div className="aspect-square w-full max-w-[400px] mx-auto">
//        <ResponsiveContainer width="100%" height="100%">
//          <PieChart>
//            <Pie
//              data={data}
//              cx="50%"
//              cy="50%"
//              labelLine={false}
//              label={renderCustomizedLabel}
//              outerRadius="70%"
//              fill="#8884d8"
//              dataKey="value"
//            >
//              {data.map((entry, index) => (
//                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//              ))}
//            </Pie>
//            <Tooltip />
//            <Legend verticalAlign="bottom" height={36}/>
//          </PieChart>
//        </ResponsiveContainer>
//      </div>
     
//      <p className="text-center mt-4 text-sm text-gray-600">
//        Total Submissions: {total}
//      </p>
//    </div>
//  );
// };

// export default SubmissionsPieChart;